import React from "react";
import { Link } from "react-router-dom";
import projects from '../data/projects';

const ProjectPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-white py-12 px-4 transition-colors duration-300">
        <h1 className="text-4xl font-bold text-center mb-10">Projects</h1>
      <div className="max-w-6xl mx-auto grid gap-8 md:grid-cols-2 lg:grid-cols-2">
        {projects.map((project) => (
          <div
            key={project.id}
            className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-lg transition duration-300"
          >
            <img
              src={project.image}
              alt={project.title}
              className="w-full h-64 object-cover rounded-lg mb-4"
            />
            <h2 className="text-2xl font-semibold mb-2">{project.title}</h2>
            <p className="text-gray-600 dark:text-gray-400 mb-4">{project.shortDescription}</p>
            <Link
              to={`/projects/${project.id}`}
              className="text-indigo-500 hover:text-indigo-700 font-medium"
            >
              Read More &rarr;
            </Link>
          </div>
        ))}
      </div>
      </div>
  );
};

export default ProjectPage;
